import classNames from 'classnames'
import { useCallback, useEffect, useState } from 'react'
import { jobDetailsIcons } from '../constants/all'
import ImageWithBasePath from './ImageWithBasePath'

export const JobDetailsShow = ({ primary_details = {}, contentV3 = [], Openings, jobHours }) => {
  const [mainJobDetails, setMainJobDetails] = useState({})
  const details = {
    Salary: primary_details?.Salary || '-',
    Location: primary_details?.Place || '-',
    Hours: jobHours || '',
    Experience: primary_details?.Experience || '-',
    Education: primary_details?.Qualification || '-',
    Gender: '-',
    Shift: '-',
    Openings
  }
  const content = [
    ['Salary', 'Experience'],
    ['Location', 'Education'],
    ['Hours', 'Gender'],
    ['Shift', 'Openings']
  ]

  useEffect(() => {
    setMainJobDetails((prv) => ({ ...prv, ...details }))
  }, [primary_details])

  useEffect(() => {
    contentV3?.['V3']?.forEach((element) => {
      let key = element?.field_key == 'Shift timing' ? 'Shift' : element?.field_key
      setMainJobDetails((prv) => ({ ...prv, [key]: element?.field_value }))
    })
  }, [contentV3])

  const data = useCallback(
    ({ isLastIndex, item, index }) => {
      return (
        <div
          className={classNames(
            'flex w-[50%] space-x-[9.13px] sm:w-[175px] md:w-full',
            index == 0 && 'border-[0px] border-r-xs border-solid border-xLigthGray md:border-[0px]',
            !isLastIndex && 'pb-[16px]',
            index == 1 && 'pl-[11px] md:pl-[0px]'
          )}
          key={index}
          id={`job_${item}`}
        >
          <div className="flex h-[38px] w-[26px] items-center justify-start">
            <ImageWithBasePath
              src={jobDetailsIcons?.[item]?.url || ''}
              width={jobDetailsIcons?.[item]?.width || 13.5}
              height={jobDetailsIcons?.[item]?.height || 9}
              alt="job details"
            />
          </div>
          <div className="spaxe-y-[4px] flex w-full flex-col">
            <div className="text-[11px] font-normal leading-[14.98px] text-[#66676B]">{item}</div>
            <div
              className={classNames(
                'text-base font-normal leading-[19.07px] text-[#000000]',
                !String(mainJobDetails[item]).split('').includes(' ') && 'max-w-[80%] truncate'
              )}
            >
              {mainJobDetails[item] || '-'}
            </div>
          </div>
        </div>
      )
    },
    [mainJobDetails, jobDetailsIcons]
  )

  return (
    <div className="flex flex-col py-[12px] font-noto-sans md:grid md:grid-cols-2 md:py-[0px] md:pt-md">
      {content.map((item, index) => {
        const isLastIndex = index == content.length - 1
        return (
          <div className="flex w-[100%]" key={index}>
            {item.map((item, index) => data({ isLastIndex, item, index }))}
          </div>
        )
      })}
    </div>
  )
}
